import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { Brand, BrandFilters } from '../../models/Brand';

const useBrandService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetBrands, setFetchingGetBrands] = useState(false);
    const [fetchingShowBrand, setFetchingShowBrand] = useState(false);
    const [fetchingStoreBrand, setFetchingStoreBrand] = useState(false);
    const [fetchingEditBrand, setFetchingEditBrand] = useState(false);
    const [fetchingCreateBrand, setFetchingCreateBrand] = useState(false);
    const [fetchingUpdateBrand, setFetchingUpdateBrand] = useState(false);
    const [fetchingDeleteBrand, setFetchingDeleteBrand] = useState(false);
    const [fetchingActiveBrand, setFetchingActiveBrand] = useState(false);

    const getBrands = (brandFilters: BrandFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(brandFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.BRAND.GET_BRANDS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetBrands
        });
    };

    const showBrand = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.BRAND.SHOW_BRAND.replace(':id', id.toString()),
            setFetching: setFetchingShowBrand
        });
    };

    const createBrand = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.BRAND.CREATE_BRAND,
            setFetching: setFetchingCreateBrand
        });
    };

    const storeBrand = (brand: Brand, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.BRAND.STORE_BRAND,
            body: brand,
            setFetching: setFetchingStoreBrand
        });
    };

    const editBrand = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.BRAND.EDIT_BRAND.replace(':id', id.toString()),
            setFetching: setFetchingEditBrand
        });
    };

    const updateBrand = (id: number, brand: Brand, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.BRAND.UPDATE_BRAND.replace(':id', id.toString()),
            body: brand,
            setFetching: setFetchingUpdateBrand
        });
    };

    const deleteBrand = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.BRAND.DELETE_BRAND.replace(':id', id.toString()),
            setFetching: setFetchingDeleteBrand
        });
    };

    const activeBrand = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.BRAND.ACTIVE_BRAND.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActiveBrand
        });
    };

    return {
        fetchingGetBrands,
        fetchingShowBrand,
        fetchingStoreBrand,
        fetchingEditBrand,
        fetchingUpdateBrand,
        fetchingDeleteBrand,
        fetchingActiveBrand,
        fetchingCreateBrand,
        getBrands,
        showBrand,
        storeBrand,
        createBrand,
        editBrand,
        updateBrand,
        deleteBrand,
        activeBrand
    };
};

export default useBrandService;
